import { takeLatest, put } from "redux-saga/effects";
import { FETCH_RESERV_REQUEST, REDIRECT_TO_LOGIN } from "./actionsTypes";
import {
  fetchReservSuccess,
  fetchReservFailure,
  redirectToLogin,
} from "./actions";
import Config from "config";
import axios from "axios";
function* fetchReserve(action) {
  const api = Config.backOffice.apiName;
  const token = localStorage.getItem("auth_token_" + api);
  try {
    const response = yield axios.get(
      `https://www.fluxod.com/${api}/fdashboards/widget_dernieres_reservations`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    yield put(fetchReservSuccess(response.data));
  } catch (error) {
    // yield put(fetchSyntheseFailure(error));
    yield put({ type: REDIRECT_TO_LOGIN });
  }
}

function* reservSaga() {
  yield takeLatest(FETCH_RESERV_REQUEST, fetchReserve);
}

export default reservSaga;
